import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import Footer from "../components/Footer/Footer"
import ResetPasswordForm from '../components/ResetPasswordForm/ResetPasswordForm'
function ResetPassword() {
  return (
    <>
<Navbar/>
{/* <PageHeader title={'ResetPassword'}/> */}
<ResetPasswordForm/>
<Footer/>
    </>
  )
}

export default ResetPassword